import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useMemo, useState } from 'react';
import { formatNumber, LineChart } from '@blockanalitica/ui';
import { useChartPeriod } from '@/hooks';

export default function HistoricTabs({ address, walletAddress }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('365');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const [data, error] = useApi({
    url: `/farms/${address}/depositors/${walletAddress}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <LineChart
        key="balance"
        data={data}
        datasets={[
          {
            xField: 'date',
            yField: 'balance'
          }
        ]}
        timeFilter={timeFilter}
        yScaleValueFormatter={(value: number) => `${formatNumber(value)}`}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
